import { Control, Controller, ControllerProps, useFormContext } from 'react-hook-form';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

export interface FormInputProps extends Omit<ControllerProps, 'name' | 'control' | 'render'> {
    datePickerProps?: DatePickerProps<Date>;
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control?: Control<any, any>;
    label?: string;
}

export default function FormInputDate({
    name,
    control,
    datePickerProps,
    label,
    ...rest
}: FormInputProps) {
    const { trigger } = useFormContext();
    return (
        <Controller
            {...rest}
            name={name}
            control={control}
            render={({
                field: { onChange, value, ...restField },
                /* fieldState: {error }, */
            }) => (
                <DatePicker
                    {...datePickerProps}
                    {...restField}
                    // helperText={error ? error.message : null}
                    // size="small"
                    // error={!!error}
                    onChange={(e) => {
                        onChange(e?.toLocaleDateString());
                        // triggering Yup validation on change
                        trigger?.(name);
                    }}
                    value={new Date(value)}
                    // fullWidth
                    label={label}
                    sx={{ width: '100%' }}
                    // margin="normal"
                    // variant="outlined"
                />
            )}
        />
    );
}
